/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddFavouriteResponse } from '../model/addFavouriteResponse';
import { Contact } from '../model/contact';
import { ContactGroup } from '../model/contactGroup';
import { ContactImage } from '../model/contactImage';
import { CreateContactGroupResponse } from '../model/createContactGroupResponse';
import { CreateContactResponse } from '../model/createContactResponse';
import { CreateDepartmentResponse } from '../model/createDepartmentResponse';
import { CreateOrganizationResponse } from '../model/createOrganizationResponse';
import { Department } from '../model/department';
import { EditContactResponse } from '../model/editContactResponse';
import { EndUser } from '../model/endUser';
import { EndUserNumber } from '../model/endUserNumber';
import { Favourite } from '../model/favourite';
import { GetAllEndUserAccessResponse } from '../model/getAllEndUserAccessResponse';
import { GetAllEndUserNumbersResponse } from '../model/getAllEndUserNumbersResponse';
import { GetContactGroupsResponse } from '../model/getContactGroupsResponse';
import { GetContactImageResponse } from '../model/getContactImageResponse';
import { GetContactResponse } from '../model/getContactResponse';
import { GetContactStatusesResponse } from '../model/getContactStatusesResponse';
import { GetContactsResponse } from '../model/getContactsResponse';
import { GetEndUserAccessResponse } from '../model/getEndUserAccessResponse';
import { GetEndUserNumbersResponse } from '../model/getEndUserNumbersResponse';
import { GetFavouritesResponse } from '../model/getFavouritesResponse';
import { GetOrganizationResponse } from '../model/getOrganizationResponse';
import { GetQueueAgentsResponse } from '../model/getQueueAgentsResponse';
import { GetQueueStatusResponse } from '../model/getQueueStatusResponse';
import { GetQueuesResponse } from '../model/getQueuesResponse';
import { GetServiceNumbersResponse } from '../model/getServiceNumbersResponse';
import { GetServiceProvidersResponse } from '../model/getServiceProvidersResponse';
import { GetSipTerminalsResponse } from '../model/getSipTerminalsResponse';
import { Organization } from '../model/organization';
import { RemoveContactResponse } from '../model/removeContactResponse';
import { RemoveFavouriteResponse } from '../model/removeFavouriteResponse';
import { Response } from '../model/response';
import { SearchOrganizationResponse } from '../model/searchOrganizationResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { DirectoryServiceInterface }                            from './directory.serviceInterface';


@Injectable()
export class DirectoryService implements DirectoryServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addFavourite1(organization?: string, login?: string, body?: Favourite, observe?: 'body', reportProgress?: boolean): Observable<AddFavouriteResponse>;
    public addFavourite1(organization?: string, login?: string, body?: Favourite, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddFavouriteResponse>>;
    public addFavourite1(organization?: string, login?: string, body?: Favourite, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddFavouriteResponse>>;
    public addFavourite1(organization?: string, login?: string, body?: Favourite, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<AddFavouriteResponse>(`${this.basePath}/directory/favourite`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public changeUserPassword1(organization?: string, login?: string, body?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public changeUserPassword1(organization?: string, login?: string, body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public changeUserPassword1(organization?: string, login?: string, body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public changeUserPassword1(organization?: string, login?: string, body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Response>(`${this.basePath}/directory/password`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createContact1(organization?: string, login?: string, body?: Contact, observe?: 'body', reportProgress?: boolean): Observable<CreateContactResponse>;
    public createContact1(organization?: string, login?: string, body?: Contact, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateContactResponse>>;
    public createContact1(organization?: string, login?: string, body?: Contact, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateContactResponse>>;
    public createContact1(organization?: string, login?: string, body?: Contact, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CreateContactResponse>(`${this.basePath}/directory/contact`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'body', reportProgress?: boolean): Observable<CreateContactGroupResponse>;
    public createContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateContactGroupResponse>>;
    public createContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateContactGroupResponse>>;
    public createContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CreateContactGroupResponse>(`${this.basePath}/directory/contactGroup`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createDepartment1(organization?: string, body?: Department, observe?: 'body', reportProgress?: boolean): Observable<CreateDepartmentResponse>;
    public createDepartment1(organization?: string, body?: Department, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateDepartmentResponse>>;
    public createDepartment1(organization?: string, body?: Department, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateDepartmentResponse>>;
    public createDepartment1(organization?: string, body?: Department, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CreateDepartmentResponse>(`${this.basePath}/directory/department`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createEndUser1(body?: EndUser, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public createEndUser1(body?: EndUser, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public createEndUser1(body?: EndUser, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public createEndUser1(body?: EndUser, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/directory/enduser`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOrganization1(organization?: string, body?: Organization, observe?: 'body', reportProgress?: boolean): Observable<CreateOrganizationResponse>;
    public createOrganization1(organization?: string, body?: Organization, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateOrganizationResponse>>;
    public createOrganization1(organization?: string, body?: Organization, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateOrganizationResponse>>;
    public createOrganization1(organization?: string, body?: Organization, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CreateOrganizationResponse>(`${this.basePath}/directory/organization`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteEndUser1(organization: string, login: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public deleteEndUser1(organization: string, login: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public deleteEndUser1(organization: string, login: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public deleteEndUser1(organization: string, login: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling deleteEndUser1.');
        }

        if (login === null || login === undefined) {
            throw new Error('Required parameter login was null or undefined when calling deleteEndUser1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/directory/enduser/${encodeURIComponent(String(organization))}/${encodeURIComponent(String(login))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrganization1(organization?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public deleteOrganization1(organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public deleteOrganization1(organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public deleteOrganization1(organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/directory/organization`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editContact1(organization?: string, login?: string, body?: Contact, observe?: 'body', reportProgress?: boolean): Observable<EditContactResponse>;
    public editContact1(organization?: string, login?: string, body?: Contact, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditContactResponse>>;
    public editContact1(organization?: string, login?: string, body?: Contact, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditContactResponse>>;
    public editContact1(organization?: string, login?: string, body?: Contact, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditContactResponse>(`${this.basePath}/directory/contact`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/directory/contactGroup`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editDepartment1(organization?: string, body?: Department, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editDepartment1(organization?: string, body?: Department, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editDepartment1(organization?: string, body?: Department, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editDepartment1(organization?: string, body?: Department, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/directory/department`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editEndUserNumber1(organization?: string, login?: string, body?: EndUserNumber, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editEndUserNumber1(organization?: string, login?: string, body?: EndUserNumber, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editEndUserNumber1(organization?: string, login?: string, body?: EndUserNumber, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editEndUserNumber1(organization?: string, login?: string, body?: EndUserNumber, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/directory/terminal`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editOrganization1(organization?: string, body?: Organization, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editOrganization1(organization?: string, body?: Organization, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editOrganization1(organization?: string, body?: Organization, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editOrganization1(organization?: string, body?: Organization, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/directory/organization`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllEndUserAccess1(organization?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAllEndUserAccessResponse>;
    public getAllEndUserAccess1(organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAllEndUserAccessResponse>>;
    public getAllEndUserAccess1(organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAllEndUserAccessResponse>>;
    public getAllEndUserAccess1(organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAllEndUserAccessResponse>(`${this.basePath}/directory/access/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllEndUserNumbers1(organization?: string, observe?: 'body', reportProgress?: boolean): Observable<GetAllEndUserNumbersResponse>;
    public getAllEndUserNumbers1(organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAllEndUserNumbersResponse>>;
    public getAllEndUserNumbers1(organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAllEndUserNumbersResponse>>;
    public getAllEndUserNumbers1(organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetAllEndUserNumbersResponse>(`${this.basePath}/directory/terminals/all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param contactId 
     * @param fullNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContact1(organization?: string, login?: string, contactId?: number, fullNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<GetContactResponse>;
    public getContact1(organization?: string, login?: string, contactId?: number, fullNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetContactResponse>>;
    public getContact1(organization?: string, login?: string, contactId?: number, fullNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetContactResponse>>;
    public getContact1(organization?: string, login?: string, contactId?: number, fullNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contactId !== undefined && contactId !== null) {
            queryParameters = queryParameters.set('contactId', <any>contactId);
        }
        if (fullNumber !== undefined && fullNumber !== null) {
            queryParameters = queryParameters.set('fullNumber', <any>fullNumber);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetContactResponse>(`${this.basePath}/directory/contact`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContactGroups1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetContactGroupsResponse>;
    public getContactGroups1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetContactGroupsResponse>>;
    public getContactGroups1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetContactGroupsResponse>>;
    public getContactGroups1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetContactGroupsResponse>(`${this.basePath}/directory/contactGroup`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param contactId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContactImage1(organization?: string, login?: string, contactId?: number, observe?: 'body', reportProgress?: boolean): Observable<GetContactImageResponse>;
    public getContactImage1(organization?: string, login?: string, contactId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetContactImageResponse>>;
    public getContactImage1(organization?: string, login?: string, contactId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetContactImageResponse>>;
    public getContactImage1(organization?: string, login?: string, contactId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contactId !== undefined && contactId !== null) {
            queryParameters = queryParameters.set('contactId', <any>contactId);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetContactImageResponse>(`${this.basePath}/directory/contactimage`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContactStatuses1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetContactStatusesResponse>;
    public getContactStatuses1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetContactStatusesResponse>>;
    public getContactStatuses1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetContactStatusesResponse>>;
    public getContactStatuses1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetContactStatusesResponse>(`${this.basePath}/directory/contactstatuses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param departmentId 
     * @param contactId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContacts1(organization?: string, login?: string, departmentId?: number, contactId?: number, observe?: 'body', reportProgress?: boolean): Observable<GetContactsResponse>;
    public getContacts1(organization?: string, login?: string, departmentId?: number, contactId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetContactsResponse>>;
    public getContacts1(organization?: string, login?: string, departmentId?: number, contactId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetContactsResponse>>;
    public getContacts1(organization?: string, login?: string, departmentId?: number, contactId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (departmentId !== undefined && departmentId !== null) {
            queryParameters = queryParameters.set('departmentId', <any>departmentId);
        }
        if (contactId !== undefined && contactId !== null) {
            queryParameters = queryParameters.set('contactId', <any>contactId);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetContactsResponse>(`${this.basePath}/directory/contacts`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEndUserAccess1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetEndUserAccessResponse>;
    public getEndUserAccess1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetEndUserAccessResponse>>;
    public getEndUserAccess1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetEndUserAccessResponse>>;
    public getEndUserAccess1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetEndUserAccessResponse>(`${this.basePath}/directory/access`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEndUserNumbers1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetEndUserNumbersResponse>;
    public getEndUserNumbers1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetEndUserNumbersResponse>>;
    public getEndUserNumbers1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetEndUserNumbersResponse>>;
    public getEndUserNumbers1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetEndUserNumbersResponse>(`${this.basePath}/directory/terminals`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFavourites1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetFavouritesResponse>;
    public getFavourites1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetFavouritesResponse>>;
    public getFavourites1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetFavouritesResponse>>;
    public getFavourites1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetFavouritesResponse>(`${this.basePath}/directory/favourite`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrganization1(organization?: string, observe?: 'body', reportProgress?: boolean): Observable<GetOrganizationResponse>;
    public getOrganization1(organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetOrganizationResponse>>;
    public getOrganization1(organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetOrganizationResponse>>;
    public getOrganization1(organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetOrganizationResponse>(`${this.basePath}/directory/organization`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param serviceNumber 
     * @param cid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueueAgents1(organization?: string, login?: string, serviceNumber?: string, cid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetQueueAgentsResponse>;
    public getQueueAgents1(organization?: string, login?: string, serviceNumber?: string, cid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetQueueAgentsResponse>>;
    public getQueueAgents1(organization?: string, login?: string, serviceNumber?: string, cid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetQueueAgentsResponse>>;
    public getQueueAgents1(organization?: string, login?: string, serviceNumber?: string, cid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceNumber !== undefined && serviceNumber !== null) {
            queryParameters = queryParameters.set('serviceNumber', <any>serviceNumber);
        }
        if (cid !== undefined && cid !== null) {
            queryParameters = queryParameters.set('cid', <any>cid);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetQueueAgentsResponse>(`${this.basePath}/directory/queueagents`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param serviceNumber 
     * @param cid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueueStatus1(organization?: string, login?: string, serviceNumber?: string, cid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetQueueStatusResponse>;
    public getQueueStatus1(organization?: string, login?: string, serviceNumber?: string, cid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetQueueStatusResponse>>;
    public getQueueStatus1(organization?: string, login?: string, serviceNumber?: string, cid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetQueueStatusResponse>>;
    public getQueueStatus1(organization?: string, login?: string, serviceNumber?: string, cid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceNumber !== undefined && serviceNumber !== null) {
            queryParameters = queryParameters.set('serviceNumber', <any>serviceNumber);
        }
        if (cid !== undefined && cid !== null) {
            queryParameters = queryParameters.set('cid', <any>cid);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetQueueStatusResponse>(`${this.basePath}/directory/queuestatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param serviceNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getQueues1(organization?: string, login?: string, serviceNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<GetQueuesResponse>;
    public getQueues1(organization?: string, login?: string, serviceNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetQueuesResponse>>;
    public getQueues1(organization?: string, login?: string, serviceNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetQueuesResponse>>;
    public getQueues1(organization?: string, login?: string, serviceNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceNumber !== undefined && serviceNumber !== null) {
            queryParameters = queryParameters.set('serviceNumber', <any>serviceNumber);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetQueuesResponse>(`${this.basePath}/directory/queues`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getServiceNumbers1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetServiceNumbersResponse>;
    public getServiceNumbers1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetServiceNumbersResponse>>;
    public getServiceNumbers1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetServiceNumbersResponse>>;
    public getServiceNumbers1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetServiceNumbersResponse>(`${this.basePath}/directory/servicenumbers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getServiceProviders1(organization?: string, observe?: 'body', reportProgress?: boolean): Observable<GetServiceProvidersResponse>;
    public getServiceProviders1(organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetServiceProvidersResponse>>;
    public getServiceProviders1(organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetServiceProvidersResponse>>;
    public getServiceProviders1(organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetServiceProvidersResponse>(`${this.basePath}/directory/serviceProvider`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSipTerminals1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetSipTerminalsResponse>;
    public getSipTerminals1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetSipTerminalsResponse>>;
    public getSipTerminals1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetSipTerminalsResponse>>;
    public getSipTerminals1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetSipTerminalsResponse>(`${this.basePath}/directory/sipTerminals`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public grantAdministratorPermission1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public grantAdministratorPermission1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public grantAdministratorPermission1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public grantAdministratorPermission1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.put<Response>(`${this.basePath}/directory/administrator`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceNumber 
     * @param componentId 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeComponentFavourite1(serviceNumber: string, componentId: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveFavouriteResponse>;
    public removeComponentFavourite1(serviceNumber: string, componentId: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveFavouriteResponse>>;
    public removeComponentFavourite1(serviceNumber: string, componentId: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveFavouriteResponse>>;
    public removeComponentFavourite1(serviceNumber: string, componentId: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceNumber === null || serviceNumber === undefined) {
            throw new Error('Required parameter serviceNumber was null or undefined when calling removeComponentFavourite1.');
        }

        if (componentId === null || componentId === undefined) {
            throw new Error('Required parameter componentId was null or undefined when calling removeComponentFavourite1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveFavouriteResponse>(`${this.basePath}/directory/componentFavourite/${encodeURIComponent(String(serviceNumber))}/${encodeURIComponent(String(componentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeContact1(organization?: string, login?: string, body?: Contact, observe?: 'body', reportProgress?: boolean): Observable<RemoveContactResponse>;
    public removeContact1(organization?: string, login?: string, body?: Contact, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveContactResponse>>;
    public removeContact1(organization?: string, login?: string, body?: Contact, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveContactResponse>>;
    public removeContact1(organization?: string, login?: string, body?: Contact, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<RemoveContactResponse>(`${this.basePath}/directory/contact`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param contactOrganization 
     * @param contactId 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeContactFavourite1(contactOrganization: string, contactId: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveFavouriteResponse>;
    public removeContactFavourite1(contactOrganization: string, contactId: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveFavouriteResponse>>;
    public removeContactFavourite1(contactOrganization: string, contactId: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveFavouriteResponse>>;
    public removeContactFavourite1(contactOrganization: string, contactId: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (contactOrganization === null || contactOrganization === undefined) {
            throw new Error('Required parameter contactOrganization was null or undefined when calling removeContactFavourite1.');
        }

        if (contactId === null || contactId === undefined) {
            throw new Error('Required parameter contactId was null or undefined when calling removeContactFavourite1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveFavouriteResponse>(`${this.basePath}/directory/contactFavourite/${encodeURIComponent(String(contactOrganization))}/${encodeURIComponent(String(contactId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeContactGroup1(organization?: string, login?: string, body?: ContactGroup, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<Response>(`${this.basePath}/directory/contactGroup`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param ownerLogin 
     * @param id 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeContactGroupWithId1(ownerLogin: string, id: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeContactGroupWithId1(ownerLogin: string, id: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeContactGroupWithId1(ownerLogin: string, id: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeContactGroupWithId1(ownerLogin: string, id: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ownerLogin === null || ownerLogin === undefined) {
            throw new Error('Required parameter ownerLogin was null or undefined when calling removeContactGroupWithId1.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeContactGroupWithId1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/directory/contactGroup/${encodeURIComponent(String(ownerLogin))}/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeContactWithId1(id: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<RemoveContactResponse>;
    public removeContactWithId1(id: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveContactResponse>>;
    public removeContactWithId1(id: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveContactResponse>>;
    public removeContactWithId1(id: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeContactWithId1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<RemoveContactResponse>(`${this.basePath}/directory/contact/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeDepartment1(organization?: string, body?: Department, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeDepartment1(organization?: string, body?: Department, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeDepartment1(organization?: string, body?: Department, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeDepartment1(organization?: string, body?: Department, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<Response>(`${this.basePath}/directory/department`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeDepartmentWithId1(id: number, organization?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeDepartmentWithId1(id: number, organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeDepartmentWithId1(id: number, organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeDepartmentWithId1(id: number, organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling removeDepartmentWithId1.');
        }


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/directory/department/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeFavourite1(organization?: string, login?: string, body?: Favourite, observe?: 'body', reportProgress?: boolean): Observable<RemoveFavouriteResponse>;
    public removeFavourite1(organization?: string, login?: string, body?: Favourite, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RemoveFavouriteResponse>>;
    public removeFavourite1(organization?: string, login?: string, body?: Favourite, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RemoveFavouriteResponse>>;
    public removeFavourite1(organization?: string, login?: string, body?: Favourite, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<RemoveFavouriteResponse>(`${this.basePath}/directory/favourite`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            } as any
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public revokeAdministratorPermission1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public revokeAdministratorPermission1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public revokeAdministratorPermission1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public revokeAdministratorPermission1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/directory/administrator`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param number 
     * @param firstName 
     * @param lastName 
     * @param company 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchContacts1(organization?: string, login?: string, number?: string, firstName?: string, lastName?: string, company?: string, observe?: 'body', reportProgress?: boolean): Observable<GetContactsResponse>;
    public searchContacts1(organization?: string, login?: string, number?: string, firstName?: string, lastName?: string, company?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetContactsResponse>>;
    public searchContacts1(organization?: string, login?: string, number?: string, firstName?: string, lastName?: string, company?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetContactsResponse>>;
    public searchContacts1(organization?: string, login?: string, number?: string, firstName?: string, lastName?: string, company?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (number !== undefined && number !== null) {
            queryParameters = queryParameters.set('number', <any>number);
        }
        if (firstName !== undefined && firstName !== null) {
            queryParameters = queryParameters.set('firstName', <any>firstName);
        }
        if (lastName !== undefined && lastName !== null) {
            queryParameters = queryParameters.set('lastName', <any>lastName);
        }
        if (company !== undefined && company !== null) {
            queryParameters = queryParameters.set('company', <any>company);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetContactsResponse>(`${this.basePath}/directory/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param queryString 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchEndUsers1(organization?: string, login?: string, queryString?: string, observe?: 'body', reportProgress?: boolean): Observable<GetContactsResponse>;
    public searchEndUsers1(organization?: string, login?: string, queryString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetContactsResponse>>;
    public searchEndUsers1(organization?: string, login?: string, queryString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetContactsResponse>>;
    public searchEndUsers1(organization?: string, login?: string, queryString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (queryString !== undefined && queryString !== null) {
            queryParameters = queryParameters.set('queryString', <any>queryString);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetContactsResponse>(`${this.basePath}/directory/searchEndUsers`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param organizationId 
     * @param organizationName 
     * @param entriesPerPage 
     * @param page 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchOrganization1(organization?: string, organizationId?: string, organizationName?: string, entriesPerPage?: number, page?: number, observe?: 'body', reportProgress?: boolean): Observable<SearchOrganizationResponse>;
    public searchOrganization1(organization?: string, organizationId?: string, organizationName?: string, entriesPerPage?: number, page?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchOrganizationResponse>>;
    public searchOrganization1(organization?: string, organizationId?: string, organizationName?: string, entriesPerPage?: number, page?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchOrganizationResponse>>;
    public searchOrganization1(organization?: string, organizationId?: string, organizationName?: string, entriesPerPage?: number, page?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (organizationId !== undefined && organizationId !== null) {
            queryParameters = queryParameters.set('organizationId', <any>organizationId);
        }
        if (organizationName !== undefined && organizationName !== null) {
            queryParameters = queryParameters.set('organizationName', <any>organizationName);
        }
        if (entriesPerPage !== undefined && entriesPerPage !== null) {
            queryParameters = queryParameters.set('entriesPerPage', <any>entriesPerPage);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SearchOrganizationResponse>(`${this.basePath}/directory/searchorganization`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param fullNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendSipPassword1(fullNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public sendSipPassword1(fullNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public sendSipPassword1(fullNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public sendSipPassword1(fullNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fullNumber === null || fullNumber === undefined) {
            throw new Error('Required parameter fullNumber was null or undefined when calling sendSipPassword1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/directory/sipPassword/${encodeURIComponent(String(fullNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param fullNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendSipPin1(fullNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public sendSipPin1(fullNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public sendSipPin1(fullNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public sendSipPin1(fullNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (fullNumber === null || fullNumber === undefined) {
            throw new Error('Required parameter fullNumber was null or undefined when calling sendSipPin1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/directory/sipPin/${encodeURIComponent(String(fullNumber))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param contactId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setContactImage1(organization?: string, login?: string, contactId?: number, body?: ContactImage, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setContactImage1(organization?: string, login?: string, contactId?: number, body?: ContactImage, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setContactImage1(organization?: string, login?: string, contactId?: number, body?: ContactImage, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setContactImage1(organization?: string, login?: string, contactId?: number, body?: ContactImage, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contactId !== undefined && contactId !== null) {
            queryParameters = queryParameters.set('contactId', <any>contactId);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/directory/contactimage`,
            body,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
